import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { ITransaction } from '../interface/transaction';
import { Entities } from '../interface/common';

interface IFetchTransactionById {
  withFavoriteInformation?: string;
  isFavorite?: string;
  id: string;
  relations?: string[];
  fields?: string[];
  skipGlobalErrorHandler?: boolean;
}
export const useFetchTransactionById = (params: IFetchTransactionById) => {
  const { id, skipGlobalErrorHandler, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const transactionUrl = `${API_URLS.TRANSACTION_BY_ID}${id}`;
  const url = queryString ? `${transactionUrl}?${queryString}` : transactionUrl;
  const query = useQuery<ITransaction, Error>({
    queryKey: ['transaction-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.TRANSACTION,
          },
          skipGlobalErrorHandler,
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
